module.exports = __webpack_public_path__ + "static/media/logo.950c4a01.svg";